import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllVideos } from "@store/action/multimedia/VideoAction";
import { MdDriveFileRenameOutline } from "react-icons/md";
import { SlScreenDesktop } from "react-icons/sl";
import { CiTimer } from "react-icons/ci";
const URL = process.env.REACT_APP_MICRO_MULTIMEDIA_URL;

const VideoLast = ({ t }) => {
  const dispatch = useDispatch();
  const Videos = useSelector((state) => state.VideoReducer);
  useEffect(() => {
    dispatch(
      getAllVideos({
        page: 1,
        per_page: 4,
      })
    );
  }, [dispatch, Videos?.total]);

  const formatDuration = (stringDuration) => {
    let duration = parseFloat(stringDuration);
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration - hours * 3600) / 60);
    const seconds = Math.floor(duration - minutes * 60);
    const formatted_duration = `${hours < 10 ? `0${hours}` : hours}:${
      minutes < 10 ? `0${minutes}` : minutes
    }:${seconds < 10 ? `0${seconds}` : seconds}`;
    return formatted_duration;
  };
  return (
    <div className="treanding_songs_wrapper release_wrapper ms_cover">
      <div className="container" style={{ maxWidth: "90%" }}>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="ms_heading_wrapper">
              <h1>{t("Recent Videos")}</h1>
            </div>
            <div className="relaese_viewall_wrapper">
              <Link to={`/Gallery/Videos/topics`}>
                {t("view all")}
                <i className="flaticon-right-arrow" />
              </Link>
            </div>
          </div>
          {Videos?.data
            ? Videos?.data?.map((el, i) => {
                return (
                  <div
                    style={{
                      marginLeft: "5px",
                      paddingTop: "5px",
                      width: "24%",
                      minWidth: "250px",
                      boxShadow: "rgba(100, 60, 0, 0.05) 0px 0px 0px 2px",
                    }}
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                    key={i}
                  >
                    <div className="treanding_slider_main_box top_artist_wrapper_new ms_cover">
                      <video
                        src={el.file_path}
                        style={{ height: "400px", objectFit: "cover" }}
                      />
                      <div className="ms_treanding_box_overlay">
                        <div className="ms_tranding_box_overlay" />
                        <div
                          style={{
                            height: "80px",
                            display: "flex",
                            aspectRatio: "1/1",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          className="tranding_play_icon various_concert_icon"
                        >
                          <Link to={`/Gallery/Videos/topics/${el.id}`}>
                            <i
                              style={{ fontSize: "50px" }}
                              className="flaticon-play-button"
                            />
                          </Link>
                        </div>
                      </div>

                      <div className="various_song_playlist">
                        <span
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            width: "100%",
                          }}
                        >
                          <MdDriveFileRenameOutline size={17} />
                          <p style={{ marginLeft: "5px" }}>
                            <Link to={`/Gallery/Videos/topics/${el.id}`}>
                              <span style={{ display: "block" }}>
                                {el.video_info.title}
                              </span>
                            </Link>
                          </p>
                        </span>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            width: "100%",
                            marginTop: "2px",
                            opacity: "1",
                          }}
                        >
                          <CiTimer size={17} />
                          <p style={{ marginLeft: "5px", fontSize: "12px" }}>
                            <Link to={`/Gallery/Videos/topics/${el.id}`}>
                              <span style={{ display: "block" }}>
                                {formatDuration(el.video_info.length_seconds)}
                              </span>
                            </Link>
                          </p>
                        </span>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            width: "100%",
                            marginTop: "2px",
                            opacity: "0.7",
                          }}
                        >
                          <SlScreenDesktop size={17} />
                          <p style={{ marginLeft: "5px", fontSize: "12px" }}>
                            <Link to={`/Gallery/Videos/topics/${el.id}`}>
                              <span style={{ display: "block" }}>
                                {el.video_info.resolution}
                              </span>
                            </Link>
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })
            : t("No recent videos")}
        </div>
      </div>
    </div>
  );
};

export default VideoLast;
